











import {Vue, Component} from 'vue-property-decorator';

@Component
export default class PageFormBtn extends Vue {
  private emitSearch(e: any) {
    this.$emit('search');
    setTimeout(()=>{
      $(e.target).blur();
    });
  }

  private emitReset() {
    this.$emit('reset');
  }
}
